import EmailsService from '@/api/admin/emails.service'

export default {
  state: {
    table: {
      rows: [],
      searchTerm: '',
    },
    email: {},
  },
  getters: {
    allEmails: state => state.table,
    getEmail: state => state.email,
  },
  actions: {
    async getEmails({ commit }) {
      const emails = await EmailsService.getEmails()
      commit('SET_EMAILS', emails)
    },
    async getEmail({ commit }, emailId) {
      const email = await EmailsService.getEmail(emailId)
      commit('SET_EMAIL', email)
    },
  },
  mutations: {
    SET_EMAILS(state, emails) {
      state.table.rows = emails
    },
    SET_EMAIL(state, email) {
      state.email = email
    },
  },
}
